module.exports = __webpack_public_path__ + "static/media/logo-arrayanes.87450591.png";